<template>
  <div>

    <c-title>Projekt bewerten</c-title>

    <c-busy v-if="loadStatus === $config.status.LOADING" />

    <div v-else>

      <c-project-summary
        :abstract="project.abstract"
        :description="project.description"
        :title="project.title"
        :image="image"
      />

      <c-title tag="h2">Bewertung</c-title>

      <c-form
        required-fields
        @submit.prevent="submit"
      >

        <c-form-rating
          id="rating"
          :errors="[{
            message: 'Dieses Feld ist erforderlich.',
            show: !$v.rating.rating.required
          }]"
          :has-error="$v.rating.rating.$error"
          :is-valid="!$v.rating.rating.$invalid"
          :max="5"
          v-model="rating.rating"
          aria-required="true"
          label="Bewertung *"
          @input="$v.rating.rating.$touch"
        />

        <c-form-textarea
          id="comment"
          :errors="[{
            message: `Bitte nicht mehr als ${$v.rating.comment.$params.maxLength.max} Zeichen.`,
            show: !$v.rating.comment.maxLength
          }]"
          :has-error="$v.rating.comment.$error"
          :is-valid="!$v.rating.comment.$invalid"
          v-model="rating.comment"
          label="Kommentar (max. 1000 Zeichen)"
          rows="6"
          @input="$v.rating.comment.$touch"
        />

        <c-button :busy="saveStatus === $config.status.SAVING">
          Abschicken
        </c-button>

      </c-form>

    </div>

  </div>
</template>

<script>
import CBusy from '@/components/CBusy'
import CButton from '@/components/CButton'
import CForm from '@/components/form/CForm'
import CFormRating from '@/components/form/CFormRating'
import CFormTextarea from '@/components/form/CFormTextarea'
import CProjectSummary from '@/components/project/CProjectSummary'
import CTitle from '@/components/CTitle'

import config from '@/config'
import handleRequestError from '@/functions/handleRequestError'
import { between, maxLength, numeric, required } from 'vuelidate/lib/validators'

export default {
  name: 'VProjectRating',

  components: {
    CBusy,
    CButton,
    CForm,
    CFormRating,
    CFormTextarea,
    CProjectSummary,
    CTitle
  },

  props: {
    ratingCode: {
      type: String
    }
  },

  data () {
    return {
      loadStatus: this.$config.status.IDLE,
      saveStatus: this.$config.status.IDLE,
      rating: {
        comment: '',
        rating: 0
      },
      project: {}
    }
  },

  validations: {
    rating: {
      comment: {
        maxLength: maxLength(1000)
      },
      rating: {
        between: between(1, 5),
        numeric,
        required
      }
    }
  },

  computed: {
    image () {
      return config.appUrl + this.project.image
    }
  },

  created () {
    this.loadStatus = this.$config.status.LOADING

    this.$api.get('projects/project/', {
      params: { rating_code: this.ratingCode }
    })
      .then(response => {
        this.project = response.data.project
        this.rating = response.data.rating
        this.loadStatus = this.$config.status.SUCCESS
      })
      .catch(() => {
        this.$store.commit('notifications/add', {
          text: 'Das Projekt kann zurzeit leider nicht geladen werden. Bitte versuchen Sie es später erneut.',
          type: 'error'
        })
        this.$router.push({ name: 'dashboard' })
      })
  },

  methods: {
    submit () {
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.$store.commit('notifications/add', {
          text: 'Bitte füllen Sie alle Felder korrekt aus.',
          type: 'error'
        })

        return
      }

      this.saveStatus = this.$config.status.SAVING

      this.$api.post('projects/rating/', {
        rating_code: this.ratingCode,
        rating: this.rating.rating,
        comment: this.rating.comment
      })
        .then(response => {
          this.$store.commit('notifications/add', {
            text: 'Vielen Dank für die Bewertung.',
            type: 'success'
          })
          this.$router.push({ name: 'dashboard' })
        })
        .catch(error => {
          handleRequestError({
            error,
            fallback: 'Ihre Bewertung kann zurzeit leider nicht gespeichert werden. Bitte versuchen Sie es später erneut.'
          })

          this.saveStatus = this.$config.status.ERROR
        })
    }
  }
}
</script>
